'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TwitterCard = function TwitterCard(_ref) {
    var card = _ref.card,
        title = _ref.title,
        description = _ref.description,
        image = _ref.image;
    return _react2.default.createElement(_reactHelmet2.default, {
        meta: [{ property: 'twitter:card', content: card }, { property: 'twitter:title', content: title }, { property: 'twitter:description', content: description }, { property: 'twitter:image', content: image }]
    });
};

TwitterCard.propTypes = {
    title: _propTypes2.default.string.isRequired,
    card: _propTypes2.default.string.isRequired,
    description: _propTypes2.default.string.isRequired,
    image: _propTypes2.default.string.isRequired
};

exports.default = TwitterCard;
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@vg/twitter-card/lib/cjs/index.js
 ** module id = 746
 ** module chunks = 1
 **/